import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DISABLE_ALL_ANIMATIONS } from '@bubble-dev/build-config';
var SVGKeyframeId = 'klarna-loader-animation-svg';
var CircleKeyframeId = 'klarna-loader-animation-circle';
var getPostFix = _ref => {
  var {
    small,
    large,
    UNSAFE_size
  } = _ref;
  return UNSAFE_size !== undefined && "custom_size_".concat(UNSAFE_size) || small && 'small' || large && 'large' || 'default';
};
export var getLoaderSize = _ref2 => {
  var {
    small,
    large,
    UNSAFE_size
  } = _ref2;
  if (UNSAFE_size !== undefined) {
    return UNSAFE_size;
  }
  var sizeName = small && 'small' || large && 'large' || 'default';
  return loaderSizes[sizeName];
};
var getStrokeDashOffset = outerDiameter => ({
  strokeDashoffsetMin: 75 * outerDiameter / 100,
  strokeDashoffsetMax: 280 * outerDiameter / 100
});
var loaderSizes = {
  small: 12,
  large: 100,
  default: 20
};
export var getKeyframes = sizeProps => {
  var postFix = getPostFix(sizeProps);
  var outerDiameter = getLoaderSize(sizeProps);
  var {
    strokeDashoffsetMax,
    strokeDashoffsetMin
  } = getStrokeDashOffset(outerDiameter);
  return "\n    @keyframes ".concat(SVGKeyframeId, "-").concat(postFix, " {\n      0% {\n        transform: rotateZ(0deg);\n      }\n      100% {\n        transform: rotateZ(360deg);\n      }\n    }\n\n    @keyframes ").concat(CircleKeyframeId, "-").concat(postFix, " {\n      0%,\n      25% {\n        stroke-dashoffset: ").concat(strokeDashoffsetMax, ";\n        transform: rotate(0);\n      }\n      50%,\n      75% {\n        stroke-dashoffset: ").concat(strokeDashoffsetMin, ";\n        transform: rotate(45deg);\n      }\n      100% {\n        stroke-dashoffset: ").concat(strokeDashoffsetMax, ";\n        transform: rotate(360deg);\n      }\n    }\n  ").replace(/ {2}|\n/g, '');
};
export var getStrokeWidth = _ref3 => {
  var {
    large,
    small,
    UNSAFE_strokeWidth
  } = _ref3;
  return UNSAFE_strokeWidth ? UNSAFE_strokeWidth : small === true ? 2.5 : large === true ? 7.5 : 2;
};
export var getDefaultStyleSheet = _ref4 => {
  var {
    designContext,
    disableAnimations,
    inverted,
    large,
    small,
    UNSAFE_colorToken,
    UNSAFE_colorTokenArgs,
    UNSAFE_size,
    UNSAFE_strokeWidth
  } = _ref4;
  var postFix = getPostFix({
    large,
    small,
    UNSAFE_size
  });
  var outerDiameter = getLoaderSize({
    large,
    small,
    UNSAFE_size
  });
  var outerRadius = outerDiameter / 2;
  var strokeWidth = getStrokeWidth({
    large,
    small,
    UNSAFE_strokeWidth
  });
  var innerRadius = outerRadius - strokeWidth / 2;
  var strokeDasharray = 2 * Math.PI * innerRadius;
  var {
    strokeDashoffsetMin
  } = getStrokeDashOffset(outerDiameter);
  return {
    svgAttrs: {
      viewBox: "0 0 ".concat(outerDiameter, " ").concat(outerDiameter)
    },
    svgStyle: _objectSpread({
      width: outerDiameter,
      height: outerDiameter
    }, disableAnimations || DISABLE_ALL_ANIMATIONS ? null : {
      animation: "".concat(SVGKeyframeId, "-").concat(postFix, " 2s linear infinite")
    }),
    circleAttrs: {
      cx: outerRadius,
      cy: outerRadius,
      r: innerRadius
    },
    circleStyle: _objectSpread({
      display: 'block',
      fill: designContext.get('colors/backgrounds/transparent').toString(),
      stroke: UNSAFE_colorToken ? designContext.get(UNSAFE_colorToken, UNSAFE_colorTokenArgs).toString() : designContext.get('loader/color', {
        colorState: inverted ? 'inverted' : 'default'
      }).toString(),
      strokeLinecap: 'square',
      strokeDasharray,
      strokeDashoffset: strokeDashoffsetMin,
      strokeWidth,
      transformOrigin: '50% 50%'
    }, disableAnimations || DISABLE_ALL_ANIMATIONS ? null : {
      animation: "".concat(CircleKeyframeId, "-").concat(postFix, " 1.4s ease-in-out infinite both")
    })
  };
};
//# sourceMappingURL=utils.js.map